import type { TenantConfig } from '@/types/TenantConfig'

export const demouk: TenantConfig = {
  ticketureTheme: true,
  teaserImageSize: {
    width: 300,
    height: 300,
  },
  postCodeAsDiscountCode: {
    filter: 'UK',
  },
  componentOptions: {
    checkoutRoute: {
      stripeWallets: true,
    },
    stripeCreditCard: {
      fontFaceStylesheet: 'https://use.typekit.net/tsu4pxd.css',
    },
    completedOrdersRoute: {
      completedImage: {
        desktop: 'assets/sandbox/static/completed.jpg',
      },
      completedContentOffset: {
        desktop: '-200px',
        mobile: '-150px',
      },
    },
  },
}
